<template>
    <v-form ref="formFiltro" v-on:submit.prevent="filtrar">
        <v-row no-gutters>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <MesInput
                    label="Período Inicial"
                    v-model="filtro.mesInicial"
                    :rules="regra.mesInicial"
                    required
                ></MesInput>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <MesInput
                    label="Período Final"
                    v-model="filtro.mesFinal"
                    :rules="regra.mesFinal"
                    required
                ></MesInput>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <input-id-java
                    label="Filial"
                    v-model="filtro.id_filial"
                    :items="lista.filial"
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Bandeira"
                    v-model="filtro.bandeira"
                    :items="lista.bandeira"
                    multiple
                    outlined
                    class="input-cinza"
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Projeto"
                    v-model="filtro.projeto"
                    :items="lista.projeto"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Espaço GC"
                    v-model="filtro.id_espaco_gc"
                    :items="lista.espaco"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Categoria"
                    v-model="filtro.id_categoria"
                    :items="lista.categoria"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Cluster"
                    :items="lista.cluster"
                    v-model="filtro.id_cluster"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Região"
                    v-model="filtro.regiao"
                    :items="lista.regiao"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Tamanho"
                    :items="lista.tamanho"
                    v-model="filtro.tamanho"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Status de Execução"
                    :items="listaCampos.execucao"
                    v-model="filtro.execucao"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <v-text-field
                    label="Número do acordo GC"
                    outlined
                    dense
                    class="input-cinza"
                    v-model="filtro.id_acordo_gc"
                ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                xl="3"
                class="px-2 ml-auto pb-2"
                align="end"
            >
                <v-btn class="ml-2 mb-1" color="primary" @click="limpar()">
                    <v-icon left>mdi-filter-off</v-icon> Limpar
                </v-btn>
                <v-btn class="ml-2 mb-1" color="primary" type="submit">
                    <v-icon left>mdi-filter</v-icon> Filtrar
                </v-btn>
            </v-col>
        </v-row>
        <v-overlay :value="overlay" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-form>
</template>

<script>
import useFiltros from "../../../hooks/useFiltros";

export default {
    setup() {
        const { isLoading, isError, isFetching, lista, error, refetch } =
            useFiltros("/acordoGC/filtrosAuditoria");

        return { isLoading, isError, isFetching, lista, error, refetch };
    },
    data() {
        return {
            listaCampos: {
                execucao: [
                    { text: "Pendente", value: ["null"] },
                    { text: "Auditado", value: ["Sim", "Não"] },
                    { text: "Executado", value: ["Sim"] },
                    { text: "Não executado", value: ["Não"] },
                ],
            },
            filtro: {},
            regra: {
                mesInicial: [
                    (v) => !!v || "Selecione um período inicial para o filtro",
                ],
                mesFinal: [
                    (v) => !!v || "Selecione um período final para o filtro",
                    (v) =>
                        (!!v && v >= this.filtro.mesInicial) ||
                        "O período final deve ser igual ou posterior ao período inicial",
                ],
            },
        };
    },
    created() {
        this.iniciaFiltro();
    },
    computed: {
        overlay() {
            return Object.keys(this.lista).length === 0 && this.isFetching;
        },
    },
    methods: {
        iniciaFiltro() {
            this.filtro = {
                bandeira: [],
                mesInicial: this.$moment().format("YYYY-MM"),
                mesFinal: this.$moment().format("YYYY-MM"),
                id_espaco_gc: [],
                id_categoria: [],
                id_acordo_gc: null,
                projeto: [],
                id_cluster: [],
                id_filial: [],
                regiao: [],
                tamanho: [],
                execucao: [],
            };
        },
        limpar() {
            this.iniciaFiltro();
        },
        filtrar() {
            this.$emit("filtrar");
        },
        validate() {
            return this.$refs.formFiltro.validate();
        },
        resetValidation() {
            try {
                this.$refs.formFiltro.resetValidation();
            } catch (error) {
                //console.log(error)
            }
        },
    },
};
</script>
